export const regionFiltersQuery = `
query RegionFilters($criteria:ConfigurationCriteria){
  filters: filters(criteria: $criteria) {
    regions {
      __typename
      id
      deeplinkId
      title
      nrOfProductConfigurations
      cookieId
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/products-api/queries/region-filters.js